// --------------------------------------------------------------------------
// Generic message toggle functionality used across the site
// --------------------------------------------------------------------------
// Author:      Sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;

    var nextSection = context.parents('.pack-request-form-section--alt').next();

    function init() {
        var checkbox = $(context).prev('.field-group').find('input[type=checkbox]');
        checkbox.on('change', function () {
            if (checkbox.is(':checked')) {
                context.show();
                nextSection.hide();
                nextSection.next().css({ 'background-color': 'white' });
            } else {
                context.hide();
                nextSection.show();
                nextSection.next().css({ 'background-color': '#f4f4f2' });
            }
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/message-toggle.js
// module id = 225
// module chunks = 0